import { BaseRouteState } from '@shared/data-access'
import { AnnuityModel } from '@sr/data-access'
import { actionsCampaign } from '@sr/routes/common'
import { types, flow } from 'mobx-state-tree'

export const TestListCampaignState = BaseRouteState.named(
  'TestListCampaignState'
)
  .props({
    annuityId: types.maybeNull(types.string),
    annuity: types.maybeNull(types.reference(AnnuityModel)),
    personId: types.maybeNull(types.string),
  })
  .actions((self) => ({
    afterAttach() {
      self.loadDependencies()
    },
    loadDependencies: flow(function* loadDependencies() {
      self.setLoading('TestListCampaignState')
      try {
        yield self.loadAnnuity()
      } finally {
        self.removeLoading('TestListCampaignState')
      }
    }),
    ...actionsCampaign(self),
  }))
